import validate from './validate';
import formik from './formik';

validate.formik = formik;

export { validate };
